import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from '../../ErrorBoundary';

const DuplicatePreviewItemTaxonomy = ({ taxonomy, values }) => {
  if (values.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary>
      <h5>{taxonomy.plural}:</h5>
      <div className="duplicated-preview-detail-content">
        <div className="file-tags-list tags-list">
          {values.map(value => (
            <span key={value.id} className="tag tag-label">
              {value.name}
            </span>
          ))}
        </div>
      </div>
    </ErrorBoundary>
  );
};

DuplicatePreviewItemTaxonomy.propTypes = {
  taxonomy: PropTypes.object.isRequired,
  values: PropTypes.array.isRequired,
};

export default DuplicatePreviewItemTaxonomy;
